import type { AppSessionUser } from './app-session.types'

function getAppSessionIdentity(session: AppSessionUser | null | undefined) {
  if (!session) {
    return null
  }

  return JSON.stringify({
    email: session.email ?? null,
    firstName: session.firstName,
    lastName: session.lastName,
    roles: session.roles.toSorted(),
    signedInBy: session.signedInBy,
  })
}

export function shouldResetAppSessionCache(
  previousSession: AppSessionUser | null | undefined,
  nextSession: AppSessionUser | null
) {
  if (typeof previousSession === 'undefined') {
    return false
  }

  return getAppSessionIdentity(previousSession) !== getAppSessionIdentity(nextSession)
}

export function shouldRefreshServerShellForSession(
  previousSession: AppSessionUser | null | undefined,
  nextSession: AppSessionUser | null,
  { forceAuthenticatedRefresh = false }: { forceAuthenticatedRefresh?: boolean } = {}
) {
  return (
    shouldResetAppSessionCache(previousSession, nextSession) ||
    (forceAuthenticatedRefresh && Boolean(nextSession)) ||
    (typeof previousSession === 'undefined' && Boolean(nextSession))
  )
}
